export class StorefrontError<TData = unknown> extends Error {
  public data: TData

  constructor(message: string, data: TData) {
    super(message)

    this.name = 'StorefrontError'
    this.data = data
  }
}

export const isStorefrontError = <TData = unknown>(
  error: unknown
): error is StorefrontError<TData> => {
  const isStorefrontErrorInstance = error instanceof StorefrontError
  const isObjectWithName =
    typeof error === 'object' && error !== null && 'name' in error

  return (
    isStorefrontErrorInstance ||
    (isObjectWithName && (error as StorefrontError).name === 'StorefrontError')
  )
}
